import { DISALLOWED_COLOR_VALUES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
import tinycolor from 'tinycolor2';
export let getBackgroundColor = color => {
  if (color) {
    let givenColor = tinycolor(color);
    if (givenColor.isValid() && !DISALLOWED_COLOR_VALUES.includes(color)) {
      return givenColor.toHexString();
    }
  }
  return '';
};